export const ZOOM_MEETING_SWAP_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
}

export const SHIFT_PLAN_ERROR_MESSAGE = {
    SUCCESS_SWAP_STATUS: 'Session swap successful.',
    FAILURE_SWAP_STATUS: 'Session swapped but unable to swap host in Zoom'
}